const REFRESH_BUFFER = 5 * 60 * 1000; // 5 minutes

const userTokens = new Map();
const refreshTimers = new Map();

self.addEventListener('install', () => {
  self.skipWaiting();
});

self.addEventListener('activate', (event) => {
  event.waitUntil(self.clients.claim());
});

self.addEventListener('message', async (event) => {
  const { type, payload } = event.data;
  switch (type) {
    case 'START_REFRESH':
      startTokenRefresh(payload);
      break;

    case 'UPDATE_TOKEN':
      updateToken(payload);
      break;

    case 'STOP_REFRESH':
      stopTokenRefresh(payload.userId);
      break;
  }
});

/**
 * Initializes token refresh monitoring for a user
 * Prevents duplicate timers for the same user
 */
function startTokenRefresh({ userId, token, expiresAt }) {
  const existing = userTokens.get(userId);
  if (existing && existing.expiresAt >= expiresAt) return;
  userTokens.set(userId, { userId, token, expiresAt });
  scheduleRefresh(userId);
}

/**
 * Updates token information after successful refresh
 * Reschedule the next refresh based on new expiration
 */
function updateToken({ userId, token, expiresAt }) {
  const existing = userTokens.get(userId);
  if (existing) {
    userTokens.set(userId, { userId, token, expiresAt });
    scheduleRefresh(userId);
  }
}

/**
 * Schedules token refresh for a specific user
 * Clears any existing timer before setting a new one
 */
function scheduleRefresh(userId) {
  const existingTimer = refreshTimers.get(userId);
  if (existingTimer) clearTimeout(existingTimer);

  const tokenData = userTokens.get(userId);

  if (!tokenData) return;
  if (tokenData.expiresAt - REFRESH_BUFFER <= 0) return;

  const timeUntilRefresh = tokenData.expiresAt - Date.now() - REFRESH_BUFFER;
  if (timeUntilRefresh <= 0) triggerRefresh(userId);
  else {
    const timer = setTimeout(() => triggerRefresh(userId), timeUntilRefresh);
    refreshTimers.set(userId, timer);
  }
}

/**
 * Triggers token refresh by notifying one client
 * Prevents duplicate refresh calls across multiple tabs
 */
async function triggerRefresh(userId) {
  const tokenData = userTokens.get(userId);
  if (!tokenData) return;

  const clients = await self.clients.matchAll();
  const clientToNotify = clients[0];

  if (clientToNotify) {
    clientToNotify.postMessage({
      type: 'REFRESH_TOKEN_REQUEST',
      payload: { userId },
    });
  }
}

/**
 * Stops token refresh monitoring for a user
 * Cleans up timers and stored token data
 */
function stopTokenRefresh(userId) {
  const timer = refreshTimers.get(userId);
  if (timer) {
    clearTimeout(timer);
    refreshTimers.delete(userId);
  }
  userTokens.delete(userId);
}
